import { Input } from "antd";
import styled from "styled-components";

export const WrapperPhone = styled.div`
  width: 274px;
`;
export const StyledInput = styled(Input)`
  min-width: auto;
  width: ${({ width }) => width || "100%"};
  margin-left: 4px;
  height: ${({ height }) => height || "44px"};
  font-size: 14px;
  border-color: ${({ borderColor }) => borderColor || "#dfe1e7"};
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  outline: none;
  box-shadow: none;
  padding-left: ${({ left }) => left || "50px"};
  &:hover,
  &:focus {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
  }
`;
export const Number = styled.div`
  position: absolute;
  z-index: 11;
  padding: 6px 0 0 10px;
  font-size: 14px;
`;
export const NumberWrap = styled.div`
  display: flex;
`;
